import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getSearchListData = async () => {
  const options = prepareRequestOptions(
    '/admin/content-sources/search-list',
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getListData = async (id, params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/content-sources/${id}/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const pullDataFromS3 = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content-sources/${id}/pull`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const pushDataToCMS = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/content-sources/push`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const previewS3Data = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content-sources/${id}/preview`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getPresignedUrl = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content-sources/${id}/presigned-url`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
